import { Button, Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectRole from '../../../components/selects/SelectRole';
import { SearchOutlined } from '@ant-design/icons';
import { useState } from "react";
import SelectGovernment from "../../../components/selects/SelectGovernment";
import SelectDepartment from "../../../components/selects/SelectDepartment";
import SelectPositions from "../../../components/selects/SelectPositions";
import SelectMultiGovernment from "../../../components/selects/SelectMultiGovernment";
import SelectMultiDepartment from "../../../components/selects/SelectMultiDepartment";
import SelectMultiPositions from "../../../components/selects/SelectMultiPositions";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterUsersFarm = (props: IProps) => {
  const { t } = useTranslation();
  const [ selectedGovernment, setSelectedGovernment ] = useState<number | null>(null);
  const [ selectedDepartment, setSelectedDepartment ] = useState<number | null>(null);

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ 16 }>
		<Col span={ 6 }>
		  <Form.Item
			label="ФИО"
			name={ props.formField.fullName }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label="ПИН"
			name={ props.formField.pin }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <Form.Item
			label="Роль"
			name={ props.formField.rolesIds }
		  >
			<SelectRole/>
		  </Form.Item>
		  <Form.Item
			label={ t('titles.governments') }
			name={ props.formField.governmentIds }
		  >
			<SelectMultiGovernment
			  value={ selectedGovernment }
			  onChange={ (id) => {
				setSelectedGovernment(id);
				setSelectedDepartment(null);

				props.form.setFieldsValue({
				  [props.formField.departmentIds]: null,
				  [props.formField.positionIds]: null
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <Form.Item
			label={ t('titles.departments') }
			name={ props.formField.departmentIds }
		  >
			<SelectMultiDepartment
			  governmentIds={ selectedGovernment !== null ? [selectedGovernment].flat() : null }
			  onChange={ (id) => {
				setSelectedDepartment(id);

				props.form.setFieldsValue({
				  [props.formField.positionIds]: null
				});
			  } }
			/>
		  </Form.Item>
		  <Form.Item
			label={ t('user.position') }
			name={ props.formField.positionIds }
		  >
			<SelectMultiPositions
			  departmentIds={ selectedDepartment !== null ? [ selectedDepartment ].flat() : null }
			/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <div style={ { marginTop: 30 } }>
			<Button
			  type="primary"
			  shape="default"
			  size="middle"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 'auto' } }
			  onClick={ props.onSearch }
			>{ t('general.search') }</Button>
			<Button
			  size="small"
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>{ t('general.reset') }</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  )
}
